<script setup>
	import { useUserStore } from "@/store/modules/user";
	import { useAppStore } from "@/store/modules/app";
	import zhCn from 'element-plus/dist/locale/zh-cn.mjs';

	const userStore = useUserStore();
	userStore.getUser();
	
</script>

<template>
	<el-config-provider :locale="zhCn">
		<router-view />
	</el-config-provider>
</template>

<style lang="scss">

</style>
